import { useEnvironment } from 'hooks/useEnvironment'
import { usdc } from 'stackup-worker'
import { base } from 'viem/chains'

export function useUSDCMetadata() {
    const { baseChain } = useEnvironment()
    return {
        address: baseChain.id === base.id ? usdc.base : usdc.baseSepolia,
        chainId: baseChain.id,
        decimals: 6,
    }
}
